/* eslint-disable array-callback-return */
import { Grid, makeStyles, createStyles, Theme } from "@material-ui/core";
import React from "react";
import { PropertyInputs } from "../../../../utils/AnnounceInterfaces";
import ImageUploading from "react-images-uploading";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Button from "@material-ui/core/Button";
import Delete from "@material-ui/icons/Delete";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import { useTranslation } from "react-i18next";
import { IconButton, ImageListItemBar } from "@mui/material";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from "@mui/icons-material/Star";
import { PreviewPhotos } from "../PreviewPhotos/PreviewPhotos";
import { PropertyService } from "../../services/PropertyService";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const styles = makeStyles((theme: Theme) =>
    createStyles({
        inpuText: {
            marginBottom: theme.spacing(5),
        },
        uploadFile: {
            width: "100%",
            background: "antiquewhite",
            padding: "14px",
            minHeight: "6em",
            marginBottom: "16px",
            fontFamily: "Josefin Sans",
            textTransform: "inherit",
            fontSize: 18,
            borderRadius: 8,
        },
        changeImage: {
            fontFamily: "Josefin Sans",
            textTransform: "inherit",
            fontSize: 14,
        },
        moveButton: {
            margin: "0 5px",
        },
    })
);

const propertyService = new PropertyService();
export function StepFour(props: {
    values: PropertyInputs;
    propertyId?: string;
    handleChangePhotos: (e: any) => void;
    searchTypeName?: string;
}) {
    const [images, setImages] = React.useState<any[]>([]);
    const [coverImage, setCoverImage] = React.useState<number>(0);
    const maxNumber = 69;
    const [uploadStatus, setUploadStatus] = React.useState<string>('');

    const getErrorMessage = (error: unknown): string => {
        if (error instanceof Error) {
            return error.message;
        }
        return String(error);
    };

    // Enhanced onChange handler with debugging
    const onChange = (imageList: any, addUpdateIndex: any) => {
        //console.group('Image Selection Debug');
        //console.log('Raw imageList from uploader:', imageList);
        
        try {
            setImages(imageList);
            const imageFiles: any = [];
            
            imageList.forEach((image: any, index: number) => {
                /*console.log(`Processing image ${index + 1}:`, {
                    originalName: image.file.name,
                    type: image.file.type,
                    size: image.file.size,
                    lastModified: image.file.lastModified
                }); */

                const filename = `${props.propertyId}_${image.file.name}`;
                const modifiedImage = {
                    ...image,
                    file: new File([image.file], filename, { type: image.file.type }),
                };
                
                /*console.log(`Modified image ${index + 1}:`, {
                    newName: modifiedImage.file.name,
                    type: modifiedImage.file.type,
                    size: modifiedImage.file.size
                }); */

                imageFiles.push(modifiedImage.file);
            });

            //console.log('Final files array to be uploaded:', imageFiles);
            props.handleChangePhotos(imageFiles);
            setUploadStatus(`${imageFiles.length} files prepared for upload`);
            
        } catch (error) {
            console.error('Error processing images:', error);
            setUploadStatus(`Error: ${getErrorMessage(error)}`);
        } finally {
            console.groupEnd();
        }
    };

    // Enhanced move functions with debugging
    const moveImageUp = async (index: number) => {
       //console.log(`Attempting to move image ${index} up`);
        if (index > 0) {
            const newImages = [...images];
            [newImages[index], newImages[index - 1]] = [newImages[index - 1], newImages[index]];
            setImages(newImages);

            try {
                //const filenames = newImages.map((img) => img.file.name);
                //console.log('Updating image order with:', filenames);
                
                /*const response = await propertyService.updateImageOrder(
                    props.propertyId || "", 
                    filenames
                );*/
                
                //console.log('Order update response:', response);
                setUploadStatus('Image order updated successfully');
            } catch (error) {
                console.error('Error updating image order:', error);
                setUploadStatus(`Error: ${getErrorMessage(error)}`);
            }
        }
    };

    const moveImageDown = async (index: number) => {
        //console.log(`Attempting to move image ${index} down`);
        if (index < images.length - 1) {
            const newImages = [...images];
            [newImages[index], newImages[index + 1]] = [newImages[index + 1], newImages[index]];
            setImages(newImages);

            try {
                //const filenames = newImages.map((img) => img.file.name);
                //console.log('Updating image order with:', filenames);
                
                /*const response = await propertyService.updateImageOrder(
                    props.propertyId || "", 
                    filenames
                );*/
                
                //console.log('Order update response:', response);
                setUploadStatus('Image order updated successfully');
            } catch (error) {
                console.error('Error updating image order:', error);
                setUploadStatus(`Error: ${getErrorMessage(error)}`);
            }
        }
    };

    // Enhanced cover image setting with debugging
    const onSetImageAsCoverById = async (index: any) => {
        //console.log(`Setting image ${index} as cover`);
        setCoverImage(index);

        try {
            //const coverImageName = images[index].file.name;
            //console.log('Setting cover image to:', coverImageName);
            
            /*const response = await propertyService.setCoverImage(
                props.propertyId || "", 
                coverImageName
            );*/
            
            //console.log('Cover image response:', response);
            setUploadStatus('Cover image set successfully');
        } catch (error) {
            console.error('Error setting cover image:', error);
            setUploadStatus(`Error: ${getErrorMessage(error)}`);
        }
    };

    // Enhanced delete function with debugging
    const onDeletePhoto = (
        idProperty: string,
        idPhoto: string,
        photoName?: string
    ) => {
        //console.log('Attempting to delete photo:', { idProperty, idPhoto, photoName });
        
        const deletePromise = photoName 
            ? propertyService.deletePropertyPhotoByName(idProperty, photoName)
            : propertyService.deletePropertyPhotoById(idProperty, idPhoto);

        deletePromise
            .then((response) => {
                //console.log('Delete response:', response);
                if (response.success) {
                    setUploadStatus('Photo deleted successfully');
                    // refreshPhotos();
                } else {
                    setUploadStatus('Delete failed: ' + (response.message || 'Unknown error'));
                }
            })
            .catch((error) => {
                console.error('Delete error:', error);
                setUploadStatus('Delete error: ' + error.message);
            });
    };
    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    const classes = styles();
    const { t } = useTranslation<'common'>();

    return (
        <Grid container>
            <Grid item lg={12} sm={12} xs={12}>
                <div className={classes.inpuText}>
                    {uploadStatus && (
                        <div style={{
                            padding: '10px',
                            margin: '10px 0',
                            backgroundColor: uploadStatus.includes('Error') ? '#ffebee' : '#e8f5e9',
                            border: uploadStatus.includes('Error') ? '1px solid #ef9a9a' : '1px solid #a5d6a7',
                            borderRadius: '4px'
                        }}>
                            {uploadStatus}
                        </div>
                    )}
                    <div>
                        <h2>{t("propriete.labels.ajouter-des-photos")}</h2>
                        {!props.values.photos?.length && (
                            <h3>{t("propriete.labels.aucunePhoto")}</h3>
                        )}
                        {props.values.photos?.length && (
                            <PreviewPhotos
                                photos={props.values.photos}
                                isUpdating={false}
                                idProperty={props.propertyId || ""}
                                onDeletePhoto={onDeletePhoto}
                            />
                        )}
                    </div>
                    <ImageUploading
                        multiple
                        value={images}
                        onChange={onChange}
                        maxNumber={maxNumber}
                        dataURLKey="data_url"
                    >
                        {({
                            imageList,
                            onImageUpload,
                            onImageRemoveAll,
                            onImageUpdate,
                            onImageRemove,
                            isDragging,
                            dragProps,
                        }) => (
                            <div className="upload__image-wrapper">
                                <label htmlFor="contained-button-file">
                                    <Button
                                        className={classes.uploadFile}
                                        variant="text"
                                        component="span"
                                        style={
                                            isDragging
                                                ? { color: "red" }
                                                : undefined
                                        }
                                        onClick={onImageUpload}
                                        {...dragProps}
                                    >
                                        <PhotoCamera
                                            style={{ marginRight: 20 }}
                                        />
                                        {t("propriete.labels.photos")}
                                    </Button>
                                </label>
                                &nbsp;
                                <Button
                                    style={{
                                        fill: "#d04343",
                                        color: "#d04343",
                                        textTransform: "initial",
                                    }}
                                    onClick={onImageRemoveAll}
                                >
                                    <Delete style={{ marginRight: 20 }} />{" "}
                                    {t(
                                        "propriete.labels.supprimerTousLesPhotos"
                                    )}
                                </Button>
                                <ImageList
                                    sx={{ maxHeight: 500 }}
                                    cols={3}
                                    rowHeight={360}
                                    gap={12}
                                >
                                    {imageList.map((image, index) => (
                                        <ImageListItem key={index}>
                                            <img
                                                src={`${image["data_url"]}}`}
                                                srcSet={`${image["data_url"]}`}
                                                alt=""
                                                loading="lazy"
                                            />
                                            <div className="image-item__btn-wrapper">
                                                <ImageListItemBar
                                                    sx={{
                                                        background:
                                                            "linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, " +
                                                            "rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
                                                    }}
                                                    position="top"
                                                    actionIcon={
                                                        <IconButton
                                                            sx={
                                                                index ===
                                                                coverImage
                                                                    ? {
                                                                          color: "gold",
                                                                      }
                                                                    : {
                                                                          color: "white",
                                                                      }
                                                            }
                                                            aria-label={`star`}
                                                            onClick={() =>
                                                                onSetImageAsCoverById(
                                                                    index
                                                                )
                                                            }
                                                        >
                                                            {index ===
                                                            coverImage ? (
                                                                <StarIcon />
                                                            ) : (
                                                                <StarBorderIcon />
                                                            )}
                                                        </IconButton>
                                                    }
                                                    actionPosition="left"
                                                />
                                                <div>
                                                    <Button
                                                        className={classes.moveButton}
                                                        variant="outlined"
                                                        onClick={() => moveImageUp(index)}
                                                        disabled={index === 0}
                                                    >
                                                        <ArrowUpwardIcon />
                                                    </Button>
                                                    <Button
                                                        className={classes.moveButton}
                                                        variant="outlined"
                                                        onClick={() => moveImageDown(index)}
                                                        disabled={index === images.length - 1}
                                                    >
                                                        <ArrowDownwardIcon />
                                                    </Button>
                                                </div>
                                                <Button
                                                    variant="outlined"
                                                    onClick={() =>
                                                        onImageUpdate(index)
                                                    }
                                                    className={
                                                        classes.changeImage
                                                    }
                                                >
                                                    {t(
                                                        "propriete.labels.changer"
                                                    )}
                                                </Button>

                                                <Button
                                                    variant="outlined"
                                                    style={{
                                                        fill: "#d04343",
                                                        color: "#d04343",
                                                    }}
                                                    onClick={() =>
                                                        onImageRemove(index)
                                                    }
                                                >
                                                    <Delete />
                                                </Button>
                                            </div>
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </div>
                        )}
                    </ImageUploading>
                </div>
            </Grid>
        </Grid>
    );
}